import { MutableRefObject } from 'react';
import { SuperFormItemProps } from '../SuperForm/interface';
import { getThumbUrl } from '../utils/dataUtils';
import { getHTMLElement } from '../utils/utils';
import { DetailPageType } from './context';
import { DEFAULT_FIELD_NAMES } from '../SuperSelect/interface';

const uploadTypes: string[] = ['Upload', 'UploadImage', 'UploadImages'];
// 提取formItems中的上传字段名
export function getUploadNames(formItems?: SuperFormItemProps[]) {
  let result: any = {};
  formItems?.forEach(item => {
    const { name, children, tabPanes, formItemType, relativePathName } = item;
    if (
      name &&
      typeof name === 'string' &&
      uploadTypes.includes(formItemType)
    ) {
      result[name] = {
        url: name,
        relativePathName: relativePathName || name,
      };
    }
    if (Array.isArray(tabPanes)) {
      tabPanes.forEach(tanPane => {
        const tanPaneChildren = tanPane.children;
        if (Array.isArray(tanPaneChildren)) {
          const childrenData = getUploadNames(
            tanPaneChildren as SuperFormItemProps[],
          );
          result = { ...result, ...childrenData };
        }
      });
    }
    if (Array.isArray(children)) {
      const childrenData = getUploadNames(children as SuperFormItemProps[]);
      result = { ...result, ...childrenData };
    }
  });
  return result;
}

export function formatInitData(initData: any, uploadNames: any) {
  const result: any = {};
  if (typeof initData === 'object') {
    for (let [key, value] of Object.entries(initData)) {
      const uploadInfo = uploadNames[key];
      if (uploadInfo) {
        let valueData: any[] = [];
        if (Array.isArray(value)) {
          valueData = value.map((v, index) => {
            if (typeof v === 'string') {
              return {
                uid: `-${index + 1}`,
                status: 'done',
                url: v,
                thumbUrl: getThumbUrl(v),
                relativePath: initData[uploadInfo.relativePathName]?.[index],
              };
            }
            return v;
          });
        }
        if (typeof value === 'string') {
          valueData = [
            {
              uid: '-1',
              status: 'done',
              url: value,
              thumbUrl: getThumbUrl(value),
              relativePath: initData[uploadInfo.relativePathName],
            },
          ];
        }
        result[key] = valueData;
      } else {
        result[key] = value;
      }
    }
  }
  return result;
}

export function getImageUrl(imageUrl?: string) {
  if (!imageUrl) return imageUrl;
  if (/^(http(s)?:\/\/)/i.test(imageUrl)) {
    try {
      const url = new URL(imageUrl);
      return url.pathname;
    } catch {
      return '';
    }
  }
  return imageUrl;
}

export function setDetailPageVisible(
  tableRef: MutableRefObject<HTMLElement | undefined>,
  detailRef: MutableRefObject<HTMLDivElement | null>,
  detailParentRef: MutableRefObject<HTMLElement | undefined>,
  visible?: boolean,
  tableId?: HTMLElement | string,
  isTableDetail?: boolean,
  hideCallback?: () => void,
) {
  if (!isTableDetail) return;
  if (!tableRef.current) {
    if (tableId) {
      const tableEl = getHTMLElement(tableId);
      if (tableEl) tableRef.current = tableEl;
    } else {
      if (detailRef.current) {
        // if (document.getElementsByClassName('yb-layout-page'))
        const parentNode = detailRef.current.parentNode as HTMLElement;
        if (parentNode) {
          if (parentNode.classList.contains('yb-layout-page-detail')) {
            detailParentRef.current = parentNode;
            const el = (parentNode.parentNode as Element)?.getElementsByClassName?.(
              'yb-layout-page',
            )?.[0];
            if (el) tableRef.current = el as HTMLElement;
          } else {
            const el = parentNode.getElementsByClassName('yb-table')[0];
            if (el) tableRef.current = el as HTMLElement;
          }
        }
      }
    }
    if (tableRef.current) {
      if (detailParentRef.current) {
        (detailParentRef.current as HTMLDivElement).style.display = visible
          ? 'block'
          : 'none';
      }
      (tableRef.current as HTMLDivElement).style.display = visible
        ? 'none'
        : '';
      hideCallback?.();
    }
  } else {
    if (detailParentRef.current) {
      (detailParentRef.current as HTMLDivElement).style.display = visible
        ? 'block'
        : 'none';
    } else {
      if (detailRef.current) {
        const parentNode = detailRef.current.parentNode as HTMLElement;
        if (parentNode) {
          if (parentNode.classList.contains('yb-layout-page-detail')) {
            detailParentRef.current = parentNode;
            (detailParentRef.current as HTMLDivElement).style.display = visible
              ? 'block'
              : 'none';
          }
        }
      }
    }
    (tableRef.current as HTMLDivElement).style.display = visible
      ? 'none'
      : '';
    hideCallback?.();
  }
}

export function setStrategyPageVisible(
  tableRef: MutableRefObject<HTMLElement | undefined>,
  detailRef: MutableRefObject<HTMLDivElement | null>,
  detailParentRef: MutableRefObject<HTMLElement | undefined>,
  visible?: boolean,
) {
  if (!tableRef.current) {
    if (detailRef.current) {
      // if (document.getElementsByClassName('yb-layout-page'))
      const parentNode = detailRef.current.parentNode as HTMLElement;
      if (parentNode) {
        if (parentNode.classList.contains('yb-layout-page-detail')) {
          detailParentRef.current = parentNode;
          const el = (parentNode.parentNode as Element)?.getElementsByClassName?.(
            'yb-layout-page',
          )?.[0];
          if (el) tableRef.current = el as HTMLElement;
        } else {
          const el = parentNode.getElementsByClassName('yb-table')[0];
          if (el) tableRef.current = el as HTMLElement;
        }
      }
    }
    if (tableRef.current) {
      if (detailParentRef.current) {
        (detailParentRef.current as HTMLDivElement).style.display = visible
          ? 'block'
          : 'none';
      }
      (tableRef.current as HTMLDivElement).style.display = visible
        ? 'none'
        : '';
    }
  } else {
    if (detailParentRef.current) {
      (detailParentRef.current as HTMLDivElement).style.display = visible
        ? 'block'
        : 'none';
    } else {
      if (detailRef.current) {
        const parentNode = detailRef.current.parentNode as HTMLElement;
        if (parentNode) {
          if (parentNode.classList.contains('yb-layout-page-detail')) {
            detailParentRef.current = parentNode;
            (detailParentRef.current as HTMLDivElement).style.display = visible
              ? 'block'
              : 'none';
          }
        }
      }
    }
    (tableRef.current as HTMLDivElement).style.display = visible
      ? 'none'
      : '';
  }
}

export function getTitle(pageType?: DetailPageType) {
  switch (pageType) {
    case 'add':
      return '新增';
    case 'detail':
      return '详情';
    case 'edit':
      return '编辑';
    default:
      return '';
  }
};

/** 根据表单值生成新的的默认选项 */
export function getInitOptions(props: {
  /** 初始默认选项 */
  initOptions?: any;
  /** 表单默认值 */
  initValues?: any;
  /** 表单默认值和label对应的字段名 */
  labelKey?: string;
  /** 表单默认值和value对应的字段名 */
  valueKey?: string;
  /** 选项和label对应的字段名 */
  labelField?: string;
  /** 选项和value对应的字段名 */
  valueField?: string;
}): any[] {
  const {
    initValues,
    labelKey,
    valueKey,
    labelField,
    valueField,
  } = props;
  const newInitOptions: any[] = [];
  if (initValues && labelKey && valueKey && labelField && valueField) {
    const label = initValues[labelKey];
    const value = initValues[valueKey];
    // 多选
    if (Array.isArray(label) && Array.isArray(value)) {
      value.forEach((item: any, index: number) => {
        const findItem = newInitOptions.find(v => v[valueField] === item);
        !findItem && newInitOptions.push({
          [valueField]: item,
          [labelField]: label[index],
        });
      });
    }
    if (typeof label === 'string' && typeof value === 'string') {
      const findItem = newInitOptions.find(v => v[valueField] === value);
      !findItem && newInitOptions.push({
        [valueField]: value,
        [labelField]: label,
      });
    }
  }
  return newInitOptions;
}
/**
 * 根据默认值生成下拉列表默认选项
 * @param formItems 表单配置
 * @param initValues 默认值
 * @returns 
 */
export function setOptionsFormItems(formItems: SuperFormItemProps[], initValues: any) {
  if (!initValues) return formItems;
  const newFormItems: SuperFormItemProps[] = [];
  formItems.forEach(item => {
    const { formItemType, children, } = item;
    switch (formItemType) {
      case 'SuperSelectTable':
        const { labelKey, valueKey, superSelectTableProps, } = item;
        if (superSelectTableProps) {
          const newInitOptions = getInitOptions({
            initValues,
            labelKey,
            valueKey,
            initOptions: superSelectTableProps?.initOptions,
            labelField: superSelectTableProps?.labelKey || DEFAULT_FIELD_NAMES.label,
            valueField: superSelectTableProps?.valueKey || DEFAULT_FIELD_NAMES.value,
          });
          newFormItems.push({
            ...item,
            superSelectTableProps: {
              ...superSelectTableProps,
              initOptions: newInitOptions,
            },
          });
        }
        break;
      case 'SelectGroupTable':
        const { namekey, valuekey, disabledRenderKey, afterSelectTableProps, } = item;
        if (afterSelectTableProps) {
          const newInitOptions = getInitOptions({
            initValues,
            labelKey: namekey,
            valueKey: valuekey,
            initOptions: afterSelectTableProps?.initOptions,
            labelField: afterSelectTableProps?.nameKey || DEFAULT_FIELD_NAMES.label,
            valueField: afterSelectTableProps?.valueKey || DEFAULT_FIELD_NAMES.value,
          });
          if (disabledRenderKey && initValues) {
            if (typeof disabledRenderKey === 'function') {
              item.disabledRender = disabledRenderKey(initValues.content);
            }
            if (typeof disabledRenderKey === 'string') {
              item.disabledRender = initValues.content[disabledRenderKey];
            }
          }
          newFormItems.push({
            ...item,
            afterSelectTableProps: {
              ...afterSelectTableProps,
              initOptions: newInitOptions,
            },
          });
        }
        break;
      case 'Group':
        if (Array.isArray(children) && children.length) {
          newFormItems.push({
            ...item,
            children: setOptionsFormItems(children, initValues),
          });
        }
        break;
      default:
        newFormItems.push(item);
    }
  });
  return newFormItems;
}
